import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import Label from './label';

export default createReactClass({
	displayName: 'ProductWizardProperty',

	propTypes: {
		facet: PropTypes.object.isRequired,
		property: PropTypes.object.isRequired,
		onSelectProperty: PropTypes.func.isRequired,
		showPreselectionItemCount: PropTypes.bool,
		width: PropTypes.number,
		isLoading: PropTypes.bool,
		highlight: PropTypes.bool,
		modificators: PropTypes.array,
	},

	getInitialState() {
		return {
			isLoading: false
		};
	},

	onClick(facet, property) {
		if (
			this.props.property.isDisabled
			|| (this.props.property.isSelected && !this.props.property.isDeselectable)
		) {
			return;
		}
		this.props.onSelectProperty(facet, property);
	},

	render() {
		const showPreselectionItemCount = this.props.showPreselectionItemCount && this.props.property.preselectionItemCount !== null;

		let params = {
			label: this.props.property.label,
			isCollapsed: this.props.property.isCollapsed,
			isDisabled: this.props.property.isDisabled,
			isSelected: this.props.property.isSelected,
			isDeselectable: this.props.property.isDeselectable,
			isQuasiSelected: this.props.property.isQuasiSelected,
			isLoading: this.props.isLoading,
			onClick: () => this.onClick(this.props.facet, this.props.property),
			width: this.props.width,
			count: showPreselectionItemCount ? this.props.property.preselectionItemCount : null,
			highlight: this.props.property.highlight,
			modificators: this.props.modificators
		};

		return (
			<Label {...params}/>
		);
	}
});
